/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFees = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15.5 11H13V6h5V4h-5V2h-2v2H8.5C6 4 4 6 4 8.5S6 13 8.5 13H11v5H5v2h6v2h2v-2h2.5c2.5 0 4.5-2 4.5-4.5S18 11 15.5 11zM11 11H8.5C7.1 11 6 9.9 6 8.5S7.1 6 8.5 6H11v5zm4.5 7H13v-5h2.5c1.4 0 2.5 1.1 2.5 2.5S16.9 18 15.5 18z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgFees as Fees };
